import {
    INICIA_NOTAS_FALTAS,
    INICIO_NOTAS_FALTAS_SUCESSO,
    BUSCA_NOTAS_FALTAS,
    BUSCA_NOTAS_FALTAS_SUCESSO,
    LISTA_CURSOS_NOTAS_FALTAS,
    LISTA_CURSOS_NOTAS_FALTAS_SUCESSO,
    LISTA_SERIES_NOTAS_FALTAS,
    LISTA_SERIES_NOTAS_FALTAS_SUCESSO,
    LISTA_TURMAS_NOTAS_FALTAS,
    LISTA_TURMAS_NOTAS_FALTAS_SUCESSO,
    LISTA_ETAPAS_NOTAS_FALTAS,
    LISTA_ETAPAS_NOTAS_FALTAS_SUCESSO,
    LISTA_DISCIPLINAS_NOTAS_FALTAS,
    LISTA_DISCIPLINAS_NOTAS_FALTAS_SUCESSO,
    LISTA_MATRICULAS_NOTAS_FALTAS,
    LISTA_MATRICULAS_NOTAS_FALTAS_SUCESSO,
    LIMPAR_NOTAS_FALTAS,
    VOLTAR_PARA_FILTROS_NOTAS_FALTAS,
    ATUALIZA_NOTA_ALUNO,
    SALVA_NOTA_FALTA,
    SALVA_PARECER_DESCRITIVO,
    HIDE_MESSAGE,
    SHOW_MESSAGE,
    ON_SHOW_SUCCESS_MESSAGE,
    SALVA_NOTA_FALTA_SUCESSO,
    SALVA_PARECER_DESCRITIVO_SUCESSO,
    SALVA_NOTA_CONSELHO,
    SALVA_NOTA_CONSELHO_SUCESSO,
    SALVA_NOTA_RECUPERACAO,
    SALVA_NOTA_RECUPERACAO_SUCESSO,
    SALVA_SITUACAO_MATRICULA,
    SALVA_SITUACAO_MATRICULA_SUCESSO
} from 'constants/ActionTypes';

// Inicialização
export const iniciaNotasFaltas = () => ({
    type: INICIA_NOTAS_FALTAS
});

export const inicioNotasFaltasSucesso = (escolas) => ({
    type: INICIO_NOTAS_FALTAS_SUCESSO,
    payload: { escolas }
});

// Busca principal
export const buscaNotasFaltas = (filtros) => ({
    type: BUSCA_NOTAS_FALTAS,
    payload: filtros
});

export const buscaNotasFaltasSucesso = (resultado) => ({
    type: BUSCA_NOTAS_FALTAS_SUCESSO,
    payload: resultado
});

// Listagem de cursos (depende de escola + ano letivo)
export const listaCursosNotasFaltas = (escolaId, anoLetivo) => ({
    type: LISTA_CURSOS_NOTAS_FALTAS,
    payload: { escolaId, anoLetivo }
});

export const listaCursosNotasFaltasSucesso = (cursos) => ({
    type: LISTA_CURSOS_NOTAS_FALTAS_SUCESSO,
    payload: cursos
});

// Listagem de séries (depende de curso)
export const listaSeriesNotasFaltas = (cursoId) => ({
    type: LISTA_SERIES_NOTAS_FALTAS,
    payload: { cursoId }
});

export const listaSeriesNotasFaltasSucesso = (series) => ({
    type: LISTA_SERIES_NOTAS_FALTAS_SUCESSO,
    payload: series
});

// Listagem de turmas (depende de ano + escola + série)
export const listaTurmasNotasFaltas = (ano, escolaId, serieId) => ({
    type: LISTA_TURMAS_NOTAS_FALTAS,
    payload: { ano, escolaId, serieId }
});

export const listaTurmasNotasFaltasSucesso = (turmas) => ({
    type: LISTA_TURMAS_NOTAS_FALTAS_SUCESSO,
    payload: turmas
});

// Listagem de etapas do ano letivo (depende de escola + ano letivo)
export const listaEtapasNotasFaltas = (escolaId, anoLetivo) => ({
    type: LISTA_ETAPAS_NOTAS_FALTAS,
    payload: { escolaId, anoLetivo }
});

export const listaEtapasNotasFaltasSucesso = (etapas) => ({
    type: LISTA_ETAPAS_NOTAS_FALTAS_SUCESSO,
    payload: etapas
});

// Listagem de disciplinas (opcional, depende de série + escola + ano letivo)
export const listaDisciplinasNotasFaltas = (escolaId, serieId, anoLetivo) => ({
    type: LISTA_DISCIPLINAS_NOTAS_FALTAS,
    payload: { escolaId, serieId, anoLetivo }
});

export const listaDisciplinasNotasFaltasSucesso = (disciplinas) => ({
    type: LISTA_DISCIPLINAS_NOTAS_FALTAS_SUCESSO,
    payload: disciplinas
});

// Listagem de matrículas (depende de turma + ano letivo)
export const listaMatriculasNotasFaltas = (turmaId, anoLetivo) => ({
    type: LISTA_MATRICULAS_NOTAS_FALTAS,
    payload: { turmaId, anoLetivo }
});

export const listaMatriculasNotasFaltasSucesso = (matriculas) => ({
    type: LISTA_MATRICULAS_NOTAS_FALTAS_SUCESSO,
    payload: matriculas
});

// Limpar filtros
export const limparNotasFaltas = () => ({
    type: LIMPAR_NOTAS_FALTAS
});

// Voltar para a tela de filtros
export const voltarParaFiltrosNotasFaltas = () => ({
    type: VOLTAR_PARA_FILTROS_NOTAS_FALTAS
});

// Atualizar nota/falta de um aluno
export const atualizaNotaAluno = (matriculaId, campo, valor) => ({
    type: ATUALIZA_NOTA_ALUNO,
    payload: { matriculaId, campo, valor }
});

// Mensagens
export const hideMessage = () => ({
    type: HIDE_MESSAGE
});

export const showAuthMessage = (message) => ({
    type: SHOW_MESSAGE,
    payload: message
});

export const showSuccessMessage = (message) => ({
    type: ON_SHOW_SUCCESS_MESSAGE,
    payload: message
});

// Salvar nota/falta individual
export const salvaNotaFalta = (dados) => ({
    type: SALVA_NOTA_FALTA,
    payload: dados
});

// Salvar parecer descritivo
export const salvaParecerDescritivo = (dados) => ({
    type: SALVA_PARECER_DESCRITIVO,
    payload: dados
});

export const salvaNotaFaltaSucesso = (dados) => ({
    type: SALVA_NOTA_FALTA_SUCESSO,
    payload: dados
});

export const salvaParecerDescritivoSucesso = (dados) => ({
    type: SALVA_PARECER_DESCRITIVO_SUCESSO,
    payload: dados
});

// Salvar nota do conselho
export const salvaNotaConselho = (dados) => ({
    type: SALVA_NOTA_CONSELHO,
    payload: dados
});

export const salvaNotaConselhoSucesso = (dados) => ({
    type: SALVA_NOTA_CONSELHO_SUCESSO,
    payload: dados
});

// Salvar nota de recuperação
export const salvaNotaRecuperacao = (dados) => ({
    type: SALVA_NOTA_RECUPERACAO,
    payload: dados
});

export const salvaNotaRecuperacaoSucesso = (dados) => ({
    type: SALVA_NOTA_RECUPERACAO_SUCESSO,
    payload: dados
});

// Salvar situação manual da matrícula
export const salvaSituacaoMatricula = (dados) => ({
    type: SALVA_SITUACAO_MATRICULA,
    payload: dados
});

export const salvaSituacaoMatriculaSucesso = (dados) => ({
    type: SALVA_SITUACAO_MATRICULA_SUCESSO,
    payload: dados
});
